"use client";

import Link from "next/link";
import { AlertTriangle } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function RootError({ error, reset }: ErrorProps) {
  const t = useTranslations("errors");

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-8 bg-background px-4">
      <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
        <AlertTriangle className="h-8 w-8 text-destructive" />
      </div>
      <div className="space-y-2 text-center max-w-md">
        <h1 className="text-2xl font-display font-bold text-foreground">
          {t("somethingWentWrong")}
        </h1>
        <p className="text-muted-foreground text-sm">
          {t("unexpectedErrorRefresh")}
        </p>
        {error.digest && (
          <p className="text-xs text-muted-foreground font-mono">
            {t("errorId", { id: error.digest })}
          </p>
        )}
      </div>
      <div className="flex gap-3">
        <Button onClick={reset} variant="outline">
          {t("tryAgain")}
        </Button>
        <Button asChild>
          <Link href="/">{t("goHome")}</Link>
        </Button>
      </div>
    </div>
  );
}
